import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { UploadButtonComponent } from './upload-button';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    UploadButtonComponent,
  ],
  imports: [
    IonicModule,
    TranslateModule.forChild(),
  ],
  exports: [
    UploadButtonComponent
  ]
})
export class UploadButtonComponentModule {}



// WEBPACK FOOTER //
// ./src/components/upload-button/upload-button.module.ts